import { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown';

const MenuItems = ({ items }) => {
  const [dropdown, setDropdown] = useState(false);
  return (
    <li className="menu-items">
      {items.subMenu ? (
        <>
          <button
            type="button"
            aria-expanded={dropdown ? 'true' : 'false'}
            onMouseEnter={() => setDropdown((prev) => !prev)}
            onMouseLeave={() => setDropdown((prev) => !prev)}
          >
            {items.title}
            {' '}
          </button>
          <Dropdown
            subMenu={items.subMenu}
            dropDown={dropdown}
          />
        </>
      ) : items.route ? (
        <Link to={items.route}>
          {items.title}
        </Link>
      ) : (
        <span>{items.title}</span>
      )}
    </li>
  );
};

MenuItems.propTypes = {
  items: PropTypes.objectOf(Object).isRequired,
};

export default MenuItems;
